<div>
  <div
    id="block-bimbo-content"
    class="block block-system block-system-main-block">
    <div class="content">
      <article data-history-node-id="1245" role="article" about="/es/404">
        <div>
          <div
            class="field field--name-body field--type-text-with-summary field--label-hidden field__item">
            <div class="gbdesk">
              <p>
                <img
                  alt=""
                  src="https://grupobimbo-com-staging-assets.s3.amazonaws.com/s3fs-public/2021-10/_error404.jpg?VersionId=cujZy3_mkZiJDjDstkjPQ8cQ3d10iPjc" />
              </p>
            </div>

            <div class="gbmob">
              <p>
                <img
                  alt=""
                  src="https://grupobimbo-com-staging-assets.s3.amazonaws.com/s3fs-public/2021-10/mob_error404.jpg?VersionId=QdmZZY8aihNQe6mD3LsN68N6x9.rCBKH" />
              </p>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</div>
